import { render, staticRenderFns } from "./Tiktok.vue?vue&type=template&id=6abbcf65&"
import script from "./Tiktok.vue?vue&type=script&lang=js&"
export * from "./Tiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports